import Hero from '../../components/Hero/Hero'
import Services from '../../components/Services/Services'
import Stats from '../../components/Stats/Stats'
import HomeAbout from '../../components/HomeAbout/HomeAbout'
import HomeContact from '../../components/HomeContact/HomeContact'

const HomeScreen = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Stats />
      <HomeAbout />
      <HomeContact />
    </div>
  )
}

export default HomeScreen 